import { render } from "./VideoLoader.vue?vue&type=template&id=dd494984"
import script from "./VideoLoader.vue?vue&type=script&lang=js"
export * from "./VideoLoader.vue?vue&type=script&lang=js"

import "./VideoLoader.vue?vue&type=style&index=0&id=dd494984&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__